<template>
  <b-container fluid="true" style="margin:20px; max-width: 1000px;" :id="`questionId-${id}`">
    <b-row>
      <b-col :id="`qtext`" sm="12" style="font-size: x-large;"><span class="question-number">{{ qnum }}.</span><span
          class="question-text" v-html="qText"></span></b-col>
    </b-row>
    <b-row v-if="greenNote && greenNote.length > 0">
      <b-col cols="2" id="greenNote" class="green-note-label text-right align-top">Green Note:</b-col>
      <b-col class="green-note align-top" cols="9"><span v-html="`${greenNote}`"></span></b-col>
    </b-row>
    <b-row v-if="questionType === 'MATRIX'">
      <b-col style="text-align: center; width: 100%;">
        <b-form-radio-group
            v-model="selectedResponse">
          <b-form-radio :style="getRadioStyle(options)"
                        v-for="option in columns"
                        :key="option"
                        :value="option"
                        name="flavour-3a"
                        size="lg"
                        @change="reportValue($event)"
                        :disabled=isViewer
          >
            <span style="font-size: 20px; margin: 0 100px 0 10px;">{{ option }} </span>
          </b-form-radio>
        </b-form-radio-group>
      </b-col>
    </b-row>
    <b-row v-else-if="questionType === 'CHECKBOX'">
      <b-col style="text-align: left; width: 100%; padding-left: 40px; font-size: large">
        <b-form-group>
          <b-form-checkbox-group
              :id="`checkbox-group-${id}`"
              v-model="selectedResponse"
              :options="choices"
              name="flavour-1"
              size="lg"
              stacked
              @change="reportValue($event)"
              :disabled=isViewer
          ></b-form-checkbox-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-else-if="questionType === 'COMMENT'">
      <b-col style="text-align: center; width: 100%; font-size: large">
        <b-form-group>
          <b-textarea :disabled=isViewer v-model="selectedResponse" @change="reportValue($event)"></b-textarea>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import Bus from "@/eventBus";

export default {
  name: "VineyardQuestion",
  props: {
    qValue: Object,
    response: [String, Array]
  },
  data() {
    return {
      options: this.qValue.options,
      choices: this.qValue.choices,
      columns: this.qValue.columns,
      selectedResponse: this.response,
      qText: this.qValue.text,
      greenNote: this.qValue.greenNote,
      qnum: this.qValue.qnum,
      questionId: this.qValue.questionId,
      helpText: this.qValue.helpText,
      name: this.qValue.name,
      questionType: this.qValue.controlType,
      id: this.qValue._id,
      isViewer: localStorage.getItem('roles') !== null && localStorage.getItem('roles').includes('VIEWER')
    }
  },
  mounted() {
    if (this.questionType === "CHECKBOX") {
      console.log("Question Id: " + this.id);
      console.log("Answer: " + this.selectedResponse);
    }
  },
  watch: {
    response: function (val) {
      this.selectedResponse = val;
    }
  },
  methods: {
    getRadioStyle: function (optionsList) {
      if (!optionsList) {
        return "font-size: x-large"
      }
      let numbOfOptions = optionsList.length;
      let padding = Math.floor(((100 - (5 * numbOfOptions)) / (numbOfOptions + 1)) / 2);
      return 'padding-left:' + padding + '%; padding-right:' + padding + '%; font-size: 16px;'
    },
    reportValue: function (event) {
      Bus.$emit('measure-answer-update', this.id, event);
    },
    isNotEditable: function (self) {
      return self.isViewer;
    },
  }

}
</script>

<style scoped>
p {
  display: flex;
  width: 600px;
}

p:before {
  padding-right: 4px;
}

.question-number {
  position: absolute;
  top: 0;
  left: 0;
  margin-right: 5px;
  text-align: right;
}

.question-text {
  padding-left: 10px;
  padding-bottom: 10px;
  margin-left: 10px;
  width: 100%;
  font-size: 20px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  display: inline-block;
}

.question-text >>> a {
  color: #28763a;
}

.green-note-label {
  color: #1c7430;
  margin-left: 15px;
  margin-top: 0;
  padding-top: 0;
  font-size: 16px;
  font-style: italic;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

.green-note {
  color: #1c7430;
  margin-left: -5px;
  margin-top: 0;
  font-size: 16px;
  font-style: italic;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}

a {
  color: darkgreen;
  font-family: "Times New Roman"
}

a:visited {
  color: orange;
}

a:link {
  color: #28763a;
}

qtext >>> a {
  color: #28763a;
}

greenNote >>> a {
  color: #28763a;
}


/*.custom-control-label ::before {
   /background: white;
   border: 2px solid #b7b9bc;
   border-radius: 100%;
   cursor: pointer;
   top: calc((100% - 16px)/2);
 }*/
/*.custom-control-label ::after {
   top: calc((100% - 16px)/2);
 }*/

</style>
